import React, { useState, useEffect } from 'react';

import PhoneInput from '../AccountForm/PhoneInput';
import useHandleFormInput from '../AccountForm/hooks/useHandleFormInputHook';
import styles from './Verify.module.scss';
import { useGetCountries } from '../../hooks/useGetCountries';
import { isPhoneNumberValid, returnOnlyNumbers } from '../AccountForm/utilities/accountFormUtilities';
import { useFriendContext } from '../../utils/ContextProviders/FriendContext';

function EditModal(props: {
  onClose: () => void;
  onSubmit: (phoneNumber: string) => void;
  phoneNumber: string;
  countryCode: string;
}) {
  const [mask, setMask] = useState('+1 (000) 000-0000');
  const [isDisable, setIsDisable] = useState(true);
  const countries = useGetCountries();
  const { formState: { phoneNumber }, handleOnChange } = useHandleFormInput();
  const { friend } = useFriendContext();
  const {
    onClose, onSubmit, phoneNumber: previousPhoneNumber, countryCode,
  } = props;

  useEffect(() => {
    if (countries.length) {
      const selectedCountry = countries.find(({ countryCode: Cc }) => (
        Cc === countryCode
      ));

      if (selectedCountry) {
        setMask(selectedCountry.phoneFormat);
      }
    }
  }, [countries.length]);

  useEffect(() => {
    const filteredPreviousPhone = returnOnlyNumbers(previousPhoneNumber);
    const filteredPhone = returnOnlyNumbers(phoneNumber);
    const isValid = (
      isPhoneNumberValid(returnOnlyNumbers(phoneNumber), friend.countryCode)
      && filteredPreviousPhone !== filteredPhone
    );
    if (isValid === isDisable) {
      setIsDisable(!isDisable);
    }
  }, [phoneNumber]);

  const handleSubmit = () => onSubmit(phoneNumber);

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modal}>
        <button
          type="button"
          aria-label="Close Modal"
          onClick={onClose}
        >
          <i className="far fa-times" />
        </button>
        <h2>Edit Mobile Phone Number</h2>
        <PhoneInput
          label="Mobile Phone Number"
          value=""
          name="phoneNumber"
          handleInput={handleOnChange}
          errorMessage="This field is required."
          fixedCountryMask={mask}
        />
        <button
          type="button"
          className={styles.button}
          onClick={handleSubmit}
          disabled={isDisable}
        >
          UPDATE
        </button>
      </div>
    </div>
  );
}

export default EditModal;
